<template>
  <div id="user-edit-account-details">
    <div class="vx-row">
      <div class="vx-col w-full">
        <h3>Tokens</h3>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-1/3">
          <label class="vs-input--label font-bold">ID Token Expiration (In Seconds)</label>
          <p>{{ data_local.ExternalIdentity.jwt_configuration.lifetime_in_seconds }}</p>
      </div>
<!--      <div class="vx-col w-1/3">-->
<!--        <label class="vs-input&#45;&#45;label font-bold">Token Refresh Behaviour</label>-->
<!--        <p>{{ token_behaviour }}</p>-->
<!--      </div>-->
    </div>

    <div class="vx-row">
      <div class="vx-col w-1/3">
        <label class="vs-input--label font-bold">JsonWebToken Signature Algorithm</label>
        <p>{{ data_local.ExternalIdentity.jwt_configuration.alg }}</p>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      data_local: JSON.parse(JSON.stringify(this.value)),
      tokenBehaviourOptions: [
        {
          label: 'Non-Rotating',
          value: 'non-rotating',
        },
        {
          label: 'Rotating',
          value: 'rotating',
        },
      ]
    }
  },
  computed: {
    token_behaviour() {
      const { rotation_type } = this.data_local.ExternalIdentity.refresh_token || {};
      const option = this.tokenBehaviourOptions.find(({value}) => value === rotation_type);
      return option ? option.label : '';
    }
  },
}
</script>
